import { CSSObject } from '@chakra-ui/react';

export const FlexWrapper: CSSObject = {
  p: ['2', '4'],
};

export const FlexInputWrapper: CSSObject = {
  label: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '13px',
  },

  '.chakra-input': {
    transition: '.3s ease-in-out',
    bg: 'beta.800',
    border: '2px',
    borderColor: 'beta.500',
    color: 'white',
    borderRightRadius: 'lg',
    fontWeight: 'semibold',

    _placeholder: {
      color: 'white',
    },

    '&:hover, &:active, &:focus, &:visited': {
      bg: 'beta.900',
      borderColor: 'beta.500',
    },
  },

  '.chakra-input__left-addon': {
    border: 'none',
    bg: 'beta.500',
    color: 'white',
    fontSize: '13px',
    fontWeight: 'black',
    borderLeftRadius: 'lg',
  },
};

export const SelectionPopupContainer: CSSObject = {
  my: [null, null, '4'],
  mx: [null, null, '4'],
  mt: '4',
  zIndex: 'docked',

  bgGradient: 'linear(to-b, alpha.500, alpha.600)',
  borderRadius: 'lg',
};

export const InfoHeader: CSSObject = {
  borderTopRadius: 'lg',
  bg: 'gamma.400',
  h: '30px',
  px: '2',
  py: '1.5',
  alignItems: 'center',
};

export const InfoText: CSSObject = {
  fontSize: '2xs',
  color: 'gamma.900',
  fontWeight: 'bold',
};

export const TextAddToBetslipButton: CSSObject = {
  filter: 'drop-shadow(0px 1px 1px rgba(247, 215, 31, 0.7))',
  w: '225px',
  _active: {
    filter: 'none',
  },
};

export const toteMultiListSelections: CSSObject = {
  color: 'white',
  px: '4',
  py: '3',
  display: 'flex',
  fontSize: 'sm',
  fontWeight: 'bold',
  boxShadow: '0 1px rgba(255, 255, 255, .15), 0 1px rgba(255, 255, 255, .15) inset',
  sx: {
    '.toteMultiLegNum': {
      mr: '8',
      '& + p > span': {
        ml: '2',
        fontWeight: 'normal',
      },
    },
    '&.last-element': {
      borderBottom: 'none',
    }
  },
};

export const toteMultiListSelectionsIcon: CSSObject = {
  mt: '-1',
  boxSize: '6',
  color: 'white',
};